import {useTranslation} from "react-i18next";
import {useState} from "react";
import {CUSTOM_ACCESS_TABS} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */
export const CustomAccessTabApp = () => {

    const { t } = useTranslation();
    const [results, setResults] = useState(null);

    const [subViewChild, setSubViewChild] = useState(CUSTOM_ACCESS_TABS.ADD_EMPLOYEES.key);
    const [isAllChecked, setIsAllChecked] = useState(false);

    return {
        t,
        results,
        setResults,

        isAllChecked,
        setIsAllChecked,
        subViewChild,
        setSubViewChild
    }
}
